import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchData } from "../../utils";
import { setNotification } from "../notificationsSlice";
import { has } from "lodash";
import { API_AUDIT_PACKAGE, API_AUDIT_PACKAGES, API_AUDIT_PACKAGE_FILES } from "../../settings";
import { schemas } from '../schemas';


export const getAuditPackageDetails = createAsyncThunk(
    "getAuditDetails",
    async({ auditNumber }, { dispatch, rejectWithValue }) => {
        try {
            let url = API_AUDIT_PACKAGES;
            if (auditNumber.endsWith("f")) {
                url = API_AUDIT_PACKAGE_FILES;
                auditNumber = auditNumber.replace("f", "");
            }
            const response = await fetchData(url + "/" + auditNumber, {}, schemas.AUDIT_PACKAGE_DETAILS);
            if (has(response, "entities") && has(response.entities, "audit")) {
                return response.entities.audit[auditNumber];
            };
        } catch (e) {
            dispatch(setNotification(e));
            return rejectWithValue({ code: e.code });
        };
        return rejectWithValue({ code: null });
    }
);

export const getFullPackageAudit = createAsyncThunk(
    "getFullPackageAudit",
    async({ packageNumber, packageName }, { dispatch, rejectWithValue }) => {
        try {
            let url = API_AUDIT_PACKAGE, searchParams = [];
            if (packageNumber) searchParams.push("id=" + packageNumber);
            if (packageName) searchParams.push("name=" + packageName);
            const response = await fetchData(url + "?" + searchParams.join("&"), {}, {});

            return { packageName: packageName, packageNumber: packageNumber, result: Object.values(response.result)};
        } catch (e) {
            dispatch(setNotification(e));
            return rejectWithValue({ code: e.code });
        };
    }
);